import { ITeamType } from '@app/@introspection';
import { addTeam, loadTeams, removeTeam } from '@app/actions';
import { AppState } from '@app/app.state';
import { Inject, Injectable } from '@rxdi/core';
import { map } from 'rxjs/operators';

import { BaseGraphqlService } from '../base';

@Injectable()
export class TeamsService extends BaseGraphqlService {
  @Inject(AppState)
  private store: AppState;

  $teams = this.store.select((state) => state.teams);

  updateTeams(team: ITeamType) {
    this.removeTeam(team);
    this.addTeam(team);
  }

  loadTeams(team: ITeamType[]) {
    this.store.dispatch(loadTeams(team));
  }

  addTeam(team: ITeamType) {
    this.store.dispatch(addTeam(team));
  }

  removeTeam(team: ITeamType) {
    this.store.dispatch(removeTeam({ id: team.id }));
  }

  deleteTeam(id: string) {
    event.preventDefault();
    event.stopPropagation();
    return this.mutate({
      mutation: 'delete-team.mutation.graphql',
      variables: { id },
    }).pipe(map((res) => res.data.deleteTeam));
  }

  subscribeToTeamCreation() {
    return this.subscribe({
      query: 'create-team.subscription.graphql',
    }).pipe(map((res) => res.data.subscribeToCreateTeam));
  }

  listTeams() {
    return this.query({
      query: 'list-team.query.graphql',
      // fetchPolicy: 'network-only',
    }).pipe(map((res) => res.data.listTeams));
  }

  createTeam() {
    return this.mutate({
      mutation: 'create-team.mutation.graphql',
      variables: { name },
    }).pipe(map((res) => res.data.createTeam));
  }
}
